/* eslint-disable max-len */
import React from 'react';


export const validatePricesColumns = [
  {
    'Header': () => <span className='nps-poll-table-title'>KATASHIKI</span>,
    'accessor': 'katashiki',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>SFX</span>,
    'accessor': 'sfx',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>MODELO</span>,
    'accessor': 'model',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>PRODUCCIÓN INICIO</span>,
    'accessor': 'start_date',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>PRODUCCIÓN FIN</span>,
    'accessor': 'end_date',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>MONEDA</span>,
    'accessor': 'currency',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>FOB</span>,
    'accessor': 'fob',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>CÓDIGO EXTERIOR</span>,
    'accessor': 'outdoor_color',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>COLOR EXTERIOR</span>,
    'accessor': 'outdoor_color_desc',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>CÓDIGO INTERIOR</span>,
    'accessor': 'indoor_color',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>COLOR INTERIOR</span>,
    'accessor': 'indoor_color_desc',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>VALOR COLOR</span>,
    'accessor': 'color_value',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>COMISIÓN</span>,
    'accessor': 'commision',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>FLETE</span>,
    'accessor': 'shipping_cost',
  },
  {
    'Header': () => <span className='nps-poll-table-title'>C&F</span>,
    'accessor': 'cif',
  },
];
